spApp.filter('unsafe', [
  '$sce',
  ($sce) => $sce.trustAsHtml
]);
